import { createSlice } from "@reduxjs/toolkit";

const timezone = {};

const TimeZoneSlice = createSlice({
    name: "timeZone",
    initialState: {
        timezone,
    },
    reducers: {
        reSetTimeZoneData(state, action){
            state.timezone = {}
        },
        setTimeZoneData(state, action) {
            state.timezone = action.payload;
        },
    },
});


export const {
    setTimeZoneData,
    reSetTimeZoneData
} = TimeZoneSlice.actions;

export default TimeZoneSlice.reducer;
